import { Formik, FormikActions, FormikProps, Form } from "formik";
import * as React from "react";
import { Router, LocationProvider } from "@reach/router";
import Axios from "axios";
import { Header } from "./Header";
import bs from "../css/bootstrap.module.css";
import NetworkService from "../network-service";
import Spinner from "./Spinner";
import { fundListMap, FundsCome } from "../support/adapters/fundsAdapter";

// Pages
import CurrentFirm from "../pages/CurrentFirm";
import TransferDetails from "../pages/TransferDetails";
import TransferInstructions from "../pages/TransferInstructions";
import PersonalInformation from "../pages/PersonalInformation";
import FundSelection from "../pages/FundSelection";
import Review from "../pages/Review";
import Sign from "../pages/Sign";
import Footer from "./Footer";
import DebugNavigation from "./DebugNavigation";
import { Debug } from "./Debug";
import { FormValues } from "../support/FormValues";
import { getInitialValues } from "../support/InitialValues";
import { rttFieldSchema } from "../support/validationSchema";
import { useConfig } from "../customHooks/useConfig";
import { history } from "../support/hashRouting";

export const RttForm: React.FunctionComponent<object> = () => {
  const config = useConfig();

  const [loading, setLoading] = React.useState(false);
  const [fundList, setFundList] = React.useState({});

  const getUiFundList = (configUrl: any) => {
    setLoading(true);
    Axios.post(
      configUrl.uiFundListUrl,
      {
        query: `query {\r\n          products(productType: "Mutual Fund", company: "ACI", format: "website", shareClass: "Investor Class ") {\r\n            productName\r\n            fundNumber\r\n            shareClassAbbreviation\r\n            shareClass\r\n            portfolioId\r\n            shareClassStatus\r\n          }\r\n        }`,
        variables: {}
      },
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then((response: { data: any }) => {
        setLoading(false);
        if (!response.data.data.products)
          window.location.replace(configUrl.errorContent);
        else setFundList(fundListMap(response.data.data.products));
      })
      .catch(() => {
        setLoading(false);
        window.location.replace(configUrl.errorContent);
      });
  };

  React.useEffect(() => {
    if (config) {
      NetworkService.setupInterceptors(config, setLoading);
      NetworkService.checkDBStatus(config, setLoading);
      getUiFundList(config);
    }
  }, [config]);

  return (
    <div>
      {loading && <Spinner />}
      <Formik
        initialValues={getInitialValues()}
        validationSchema={rttFieldSchema}
        onSubmit={(values: FormValues, actions: FormikActions<FormValues>) => {
          if (config) {
            const submitValues = {};
            Object.keys(values).forEach(key => {
              if (
                values[key as keyof typeof values] !== "" &&
                values[key as keyof typeof values] !== undefined &&
                values[key as keyof typeof values] !== null
              ) {
                Object.assign(submitValues, values);
                // eslint-disable-next-line spaced-comment
                //submitValues[key] = values[key as keyof typeof values];
              }
            });

            Axios.post(config.uiFormSubmitUrl, submitValues)
              .then((res: any) => {
                // Redirect to AEM content page
                window.location.replace(config.uiFormSubmitCompleteUrl);
              })
              .catch((error: any) => {
                actions.setSubmitting(false);
              });
          }
        }}
        render={(formikBag: FormikProps<FormValues>) => (
          <React.Fragment>
            <Header />
            <LocationProvider history={history}>
              <div className={bs.container}>
                <div id="agreementId" style={{ fontSize: "0" }}>
                  {formikBag.values.agreementId}
                </div>
                <div className={bs.row}>
                  <div className={bs["col-md-12"]}>
                    <Form placeholder={""}>
                      <Router>
                        <CurrentFirm path="/" formikBag={formikBag} />
                        <TransferDetails
                          path="/transferDetails"
                          formikBag={formikBag}
                        />
                        <TransferInstructions
                          path="/transferInstructions"
                          formikBag={formikBag}
                        />
                        <PersonalInformation
                          path="/personalInformation"
                          formikBag={formikBag}
                        />
                        <FundSelection
                          path="/fundSelection"
                          formikBag={formikBag}
                          fundList={fundList as FundsCome}
                        />
                        <Review path="/review" formikBag={formikBag} />
                        <Sign path="/sign" formikBag={formikBag} />
                      </Router>
                    </Form>
                  </div>
                </div>
              </div>
            </LocationProvider>
            <Footer />
            {config && config.debug && <Debug />}
          </React.Fragment>
        )}
      />
      {config && config.debug && <DebugNavigation />}
    </div>
  );
};

export default RttForm;
